"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _require = require("os"),
    EOL = _require.EOL;

var Blob = require("../generated/Blob");

function convertLineEndingsToNative(s) {
  return s.replace(/\r\n|\r|\n/g, EOL);
}

exports.implementation = /*#__PURE__*/function () {
  function BlobImpl(args) {
    _classCallCheck(this, BlobImpl);

    var parts = args[0];
    var properties = args[1];
    var buffers = [];

    if (parts !== undefined) {
      var _iterator = _createForOfIteratorHelper(parts),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var part = _step.value;
          var buffer = void 0;

          if (part instanceof ArrayBuffer) {
            buffer = Buffer.from(part);
          } else if (ArrayBuffer.isView(part)) {
            buffer = Buffer.from(part.buffer, part.byteOffset, part.byteLength);
          } else if (Blob.isImpl(part)) {
            buffer = part._buffer;
          } else {
            var s = part;

            if (properties.endings === "native") {
              s = convertLineEndingsToNative(part);
            }

            buffer = Buffer.from(s);
          }

          buffers.push(buffer);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    this._buffer = Buffer.concat(buffers);
    this.type = properties.type;

    if (/[^\u0020-\u007E]/.test(this.type)) {
      this.type = "";
    } else {
      this.type = this.type.toLowerCase();
    }
  }

  _createClass(BlobImpl, [{
    key: "slice",
    value: function slice(start, end, contentType) {
      var size = this.size;
      var relativeStart;
      var relativeEnd;
      var relativeContentType;

      if (start === undefined) {
        relativeStart = 0;
      } else if (start < 0) {
        relativeStart = Math.max(size + start, 0);
      } else {
        relativeStart = Math.min(start, size);
      }

      if (end === undefined) {
        relativeEnd = size;
      } else if (end < 0) {
        relativeEnd = Math.max(size + end, 0);
      } else {
        relativeEnd = Math.min(end, size);
      }

      if (contentType === undefined) {
        relativeContentType = "";
      } else {
        // sanitization (lower case and invalid char check) is done in the
        // constructor
        relativeContentType = contentType;
      }

      var span = Math.max(relativeEnd - relativeStart, 0);
      var buffer = this._buffer;
      var slicedBuffer = buffer.slice(relativeStart, relativeStart + span);
      var blob = Blob.createImpl([[], {
        type: relativeContentType
      }], {});
      blob._buffer = slicedBuffer;
      return blob;
    }
  }, {
    key: "size",
    get: function get() {
      return this._buffer.length;
    }
  }]);

  return BlobImpl;
}();